import { render, staticRenderFns } from "./betalock.vue?vue&type=template&id=19dd6b4a&scoped=true"
import script from "./betalock.vue?vue&type=script&lang=js"
export * from "./betalock.vue?vue&type=script&lang=js"
import style0 from "./betalock.vue?vue&type=style&index=0&id=19dd6b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd6b4a",
  null
  
)

export default component.exports